<template>
  <v-list-item @click.stop="dialog = true">
    <v-list-item-icon>
      <v-icon>mdi-account</v-icon>
    </v-list-item-icon>
    <v-list-item-content>Account</v-list-item-content>
    <v-dialog
      v-model="dialog"
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline">User account</v-card-title>
        <v-card-text>
          <div class="margin-top-one">
            <span class="bold paragraph-two">User authenticated: </span>
            <span class="paragraph-two">{{ isAuthenticated ? 'Yes' : 'No' }}</span>
          </div>
          <div class="margin-top-one">
            <span class="bold paragraph-two">User: </span>
            <span class="paragraph-two">{{ user ? user : 'No user' }}</span>
          </div>
          <div class="margin-top-one">
            <span class="bold paragraph-two">Authentication type: </span>
            <span class="paragraph-two">{{ authentication }}</span>
          </div>
          <div class="margin-top-one" 
               v-if="isAuthenticated && groups"
          >
            <span class="bold paragraph-two">Groups: </span>
            <span class="paragraph-two">{{ groups.join(", ") }}</span>
          </div>
        </v-card-text>
        <v-card-actions v-if="isAuthenticated">
          <v-spacer></v-spacer>
          <ChangePassword v-if="authentication === 'BuiltIn' && isAuthenticated" />
          <v-btn text
                 :href="'/user/logout'"
          >Logout</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-item>
</template>

<script>
import ChangePassword from './ChangePassword';

export default {
  name:       "User",
  props:      ['on', 'user' , 'authentication' , 'isAuthenticated', 'groups'],
  components: {ChangePassword},
  data:       function () {
    return {
      dialog: false,
    }
  },
}
</script>

<style scoped>
</style>
